import React from 'react';
import './About.css';

import { Button, Heading } from '../../../components'; // Import necessary components from the components directory
import { about, images } from '../../../constants'; // Import the about data and images from the constants directory

import { FaCar } from 'react-icons/fa'; // Import the FaCar icon from react-icons/fa for use in the experience section



const About = () => { 
  return (
    <section className="about">

      {/* About Image */}
      <div className="image">

        <div className="sub-image one">
          <img src={images.about1} alt='Car Dealer About 1' />
          <img src={images.about2} alt='Car Dealer About 2' />
        </div>

        <div className="sub-image two">

          <img src={images.about3} alt='Car Dealer About 3' />

          {/* Experience Section: Displays years of experience and a description */}
          <div className="experience">
            <div className='icon'><FaCar /></div>
            <div className='text'>
              <span>{about.experience.years}</span> <br /> {about.experience.text}
            </div>
          </div>

        </div>

      </div>

      {/* About Content */}
      <div className="content">
        <Heading title={about.heading} subTitle={about.sub} sideHeading={true} />

        {/* Description */}
        <p>{about.description}</p>

        {/* Key Features */}
        <ul className="about-section-points">
          {about.points.map((point, index) => (
            <li key={index}>
              <div className='icon'>{point.icon}</div>
              <div className='text'>
                <h5>{point.title}</h5>
                <p>{point.content}</p>
              </div>
            </li>
          ))}
        </ul>

        {/* Button Component: Links to a specific page or action */}
        <Button link={about.button.link} title={about.button.text} />

      </div>
    </section>
  );
}

export default About;